import { AgentView } from "../ws7/agent/AgentView";
import "../ws7/ws7.css";

/** /agent: conventions, routes with scopes, queues, procedures (WS7). */
export function AgentPage() {
  return <AgentView />;
}
